export const getProfessionals = (professionals) => ({
    type: 'GET_PROFESSIONALS',
    payload: professionals
});